var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }